import { classNameBindings } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';
import { TextField } from '@ember/legacy-built-in-components';
import '@ember/object';

@classNameBindings('hasError:error', 'hasError:is-error')
export default class ErrorInput extends TextField {
  hasError = false;
  clearErrorOnEdits = true;

  @observes('value')
  clearError() {
    if (this.get('clearErrorOnEdits')) {
      return this.set('hasError', false);
    }
  }
}
